import axios from "axios";
import { decryptData, encryptData } from "./decryption";
import { toast } from "react-toastify";
import { createHmacSignature } from "./hmac";
import { getSyncedTimestampSec, updateOffsetFromResponse } from "./timeSync";

// Base URL is read from environment variable; falls back to localhost for local dev.
// Set REACT_APP_API_BASE_URL in tempmail-frontend/.env or .env.local
const REACT_APP_API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.tempmailpimath.id.vn/api";

// const REACT_APP_API_BASE_URL =
//   process.env.REACT_APP_API_BASE_URL || "http://localhost:4001/api";

export const REACT_APP_API_UPLOAD_URL = "http://localhost:4000";
// Tạo instance Axios
const apiClient = axios.create({
  baseURL: REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request Interceptor
apiClient.interceptors.request.use(
  (config) => {
    const jwt = localStorage.getItem("jwt");
    if (jwt) {
      const data = JSON.parse(jwt);
      config.headers["Authorization"] = `Bearer ${data?.token}`;
    }

    // ====== ENCRYPT BODY (GIỮ NGUYÊN CỦA BẠN) ======
    const skipEncryptRoutes = ["/upload/image", "/upload/file"];
    const shouldSkip = skipEncryptRoutes.some((r) => config.url?.includes(r));

    const isFormData =
      typeof FormData !== "undefined" && config.data instanceof FormData;

    let finalBody = config.data;

    if (
      !shouldSkip &&
      !isFormData &&
      config.data &&
      typeof config.data === "object"
    ) {
      // finalBody = encryptData(config.data);
      finalBody = config.data;
      config.data = finalBody;
    }

    // ====== HMAC SIGNATURE (KÝ TRÊN BODY ĐÃ ENCRYPT) ======
    const timestamp = getSyncedTimestampSec();
    const clientId = process.env.REACT_APP_HMAC_CLIENT_ID;
    const secret = process.env.REACT_APP_HMAC_SECRET;

    const path = new URL(config.url, config.baseURL).pathname;
    const fullPath = `/api${path}`;

    const signature = createHmacSignature({
      method: config.method,
      url: fullPath,
      timestamp,
      body: finalBody,
      secret,
    });

    config.headers["x-client-id"] = clientId;
    config.headers["x-timestamp"] = timestamp;
    config.headers["x-signature"] = signature;
    return config;
  },
  (error) => Promise.reject(error),
);

apiClient.interceptors.response.use(
  (response) => {
    updateOffsetFromResponse(response);
    // return decryptData(response.data);
    return response.data;
  },
  async (error) => {
    const res = error?.response;
    const cfg = error?.config;

    if (res) {
      updateOffsetFromResponse(res);

      const status = res.status;
      const errorCode = res.data?.errorCode;
      const message = String(res.data?.message || "");

      const isTimestampExpired =
        status === 401 &&
        (errorCode === "HMAC_EXPIRED" ||
          errorCode === "TIMESTAMP_EXPIRED" ||
          (/expired/i.test(message) && /(hmac|timestamp)/i.test(message)));

      // ✅ Retry đúng 1 lần nếu lỗi do timestamp
      if (isTimestampExpired && cfg && !cfg.__tsRetried) {
        cfg.__tsRetried = true;

        // ✅ tránh double-encrypt (cần request interceptor lưu __rawData)
        if (cfg.__rawData !== undefined) cfg.data = cfg.__rawData;

        return apiClient(cfg); // request interceptor sẽ ký lại timestamp + signature
      }

      // ❗401 thật sự (token hết hạn/invalid) -> mới xoá JWT
      if (status === 401 && !isTimestampExpired) {
        localStorage.removeItem("jwt");
        localStorage.removeItem("user");

        // Chỉ redirect nếu không phải đang ở trang login
        if (!window.location.pathname.includes("/login")) {
          window.location.href = "/login";
        }
      }
    }

    return Promise.reject(error);
  },
);

// Các hàm HTTP tiện dụng
export const get = (url, config = {}) => apiClient.get(url, config);
export const post = (url, data, config = {}) =>
  apiClient.post(url, data, config);
export const put = (url, data, config = {}) => apiClient.put(url, data, config);
export const del = (url, config = {}) => apiClient.delete(url, config);
export const patch = (url, data, config = {}) =>
  apiClient.patch(url, data, config);

export default apiClient;
